import {
      SocialDefaultImage,
      ScanAndThruSolutionOgImage
} from "../utils/imageConst";

export const HomeMeta = {
      metaTitle: `Smart Self Checkout System | Scan, Pay, & Go Solution | Scan ‘N’ Thru`,
      metaDescription: "Revolutionize your retail business with Scan ‘N’ Thru's cutting-edge self checkout technology. Boost efficiency, reduce costs, and delight your customers.",
      ogTitle: "",
      ogDescription: "",
      ogType: "website",
      ogSiteName: "",
      ogImage: ScanAndThruSolutionOgImage,
      twitterCard: "",
      twitterCreator: "",
      twitterTitle: "",
      twitterDescription: "",
      twitterImage: ScanAndThruSolutionOgImage
};

export const BlogMeta = {
      metaTitle: `Mobile Finance Latest Trends, Tips, News and Updates - Scan ‘N’ Thru`,
      metaDescription: "Get Mobile Finance Latest Trends, Tips, News, Updates, and many more through Scan ‘N’ Thru blogs and articles.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const BlogCategoryMeta = {
      metaTitle: `Read the latest fintech blogs`,
      metaDescription: "Explore Scan ‘N’ Thru’s well-researched blogs and articles to access the latest trends, tips, news, updates, and expert insights.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const BlogAuthorMeta = {
      metaTitle: `Author bio of our Fintech Expert`,
      metaDescription: "Gain valuable insights on various FinTech topics from our expert author. Stay updated on industry trends & innovations at Scan ‘N’ Thru's blog.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const ContactUsMeta = {
      metaTitle: `Contact Us | Scan ‘N’ Thru | Retail Self Checkout Solution`,
      metaDescription: "Reach out to Scan ‘N’ Thru for seamless, efficient, and customer-friendly self checkout solution. We are here to assist you with all your questions.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const ThankYouMeta = {
      metaTitle: `Scan & Pay | Self checkout solution | Scan ‘N’ Thru`,
      metaDescription: "You’re one step closer to a reliable Self checkout solution for your business. We are a seamless, convenient & customized fintech solution.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const AboutMeta = {
      metaTitle: `Reliable self-checkout solution | About us - Scan ‘N’ Thru`,
      metaDescription: "Learn about Scan ‘N’ Thru’s exceptional self-checkout solution for retailers available globally. Streamline checkout and reduce wait times effortlessly.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const MobileCheckoutMeta = {
      metaTitle: `Scan ‘N’ Thru | Mobile Checkout | Retail Self Checkout Solution`,
      metaDescription: "Discover how Scan ‘N’ Thru’s mobile checkout works; and how it can optimize your retail operations, and delight your customers.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const PrivacypolicyMeta = {
      metaTitle: `Cloud-native Financial Digital Wallet Software Privacy Policy`,
      metaDescription: "Privacy Policy for our cloud-native financial digital wallet software solutions. Your trust & security matters. We provide complete transparency in our policy.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const WhoWeServeMeta = {
      metaTitle: `Who We Serve | Self-Checkout Solution - Scan ‘N’ Thru`,
      metaDescription: "Discover the wide range of retail stores we can serve with our self-checkout solution to transform your customers’ shopping experience. Scan ‘N’ Thru.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const LoyaltyandrewardsprogramsMeta = {
      metaTitle: `Customer Loyalty Rewards Management Solution - Scan'N'Thru`,
      metaDescription: "Transform your customers’ shopping experience with customer loyalty & rewards management solution by Scan ‘N’ Thru. Increase engagement and boost profits.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};